import { render, staticRenderFns } from "./authoritysearch_test.vue?vue&type=template&id=131fbe9a&scoped=true&"
import script from "./authoritysearch_test.vue?vue&type=script&lang=js&"
export * from "./authoritysearch_test.vue?vue&type=script&lang=js&"
import style0 from "./authoritysearch_test.vue?vue&type=style&index=0&id=131fbe9a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131fbe9a",
  null
  
)

export default component.exports